import { useEffect } from 'react';
import { useHistory } from 'react-router';

const useAuthorizationReload = (): void => {
  const history = useHistory();

  useEffect(() => {
    const isLogin = JSON.parse(sessionStorage.getItem('member_info') || '{}');
    if (isLogin.result) {
      const currentPage = history.location.pathname;
      history.push(currentPage);
    } else {
      sessionStorage.clear();
      const url = '/';
      history.push(url);
    }
  }, [history]);
};

export default useAuthorizationReload;
